import { FunctionComponent, JSX } from 'react'
import { Typography } from '@mui/material'

import styles from './errorMessage.module.scss'

interface ErrorMessageProps {
    id?: string
    error: string
    className?: string
}

const ErrorMessage: FunctionComponent<ErrorMessageProps> = ({
    id,
    error,
    className
}: ErrorMessageProps): JSX.Element | null => {
    return error ? (
        <Typography id={id} color='error' variant='caption' className={`${styles.error} ${className}`}>
            {error}
        </Typography>
    ) : null
}

export default ErrorMessage
